// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1d7lE","title":"styles_title__3DvCi"};